/* eslint-disable import/no-deprecated */
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { API } from '@aws-amplify/api';
import { Amplify } from '@aws-amplify/core';
import { Store } from '@ngxs/store';
import { SetIsLogedIn } from 'src/app/features/auth/redux';
import { LoadCampaign } from 'src/app/features/campaigns/redux';
import { LoadMetadata } from 'src/app/features/robot-family-metadata/redux';
import { APIS } from 'src/app/shared/constants/api-constants';
import { ENVIRONMENT } from 'src/environments/environment';
import { CONFIG } from '../../../environments/environment';
import { LoadContent } from '../../features/content/redux/content.actions';
import { LoadSurveys } from '../../features/surveys/redux/surveys.actions';

@Injectable({
  providedIn: 'root'
})
export class AmplifyService {
  public flag = true;
  constructor(private store: Store, private router: Router) {}

  public async getAPis() {
    API.get(APIS.DEV, `/${ENVIRONMENT.name}/config-s3`, {})
      .then((response) => {
        response.forEach((element) => {
          CONFIG.API.endpoints.push(element);
          Amplify.configure(CONFIG);
        });
        if (this.flag) {
          this.insightGet();
        }
      })
      .catch((error) => {
        console.error('Error occured ', error);
      });
  }

  public insightGet() {
    this.flag = false;
    this.store.dispatch(new SetIsLogedIn(true));
    this.router.navigate(['/quick-start'], { replaceUrl: true });
  }

  public loadInitialData() {
    this.store.dispatch(new LoadCampaign());
    this.store.dispatch(new LoadContent());
    this.store.dispatch(new LoadSurveys());
    this.store.dispatch(new LoadMetadata());
  }
}
